import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getStockAdjustmentApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'STOCK_ADJUSTMENT_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到調整單資料';
  }

  if (
    code === 'STOCK_ADJUSTMENT_ISSUE_REASON_REQUIRED'
    || code === 'ISSUE_REASON_REQUIRED'
  ) {
    return data?.message || '請填寫開單原因';
  }

  if (
    code === 'STOCK_ADJUSTMENT_LINE_ADJUSTMENT_QTY_INVALID'
    || code === 'ADJUSTMENT_QTY_INVALID'
    || code === 'STOCK_ADJUSTMENT_LINE_BASE_QTY_INVALID'
    || code === 'BASE_QTY_INVALID'
    || code === 'STOCK_ADJUSTMENT_BASE_QTY_REQUIRED'
  ) {
    return data?.message || '調整量須為非 0 整數';
  }

  if (code === 'STOCK_ADJUSTMENT_BELOW_RESERVED_QUANTITY') {
    return data?.message || '調整後數量低於已保留量';
  }

  if (code === 'INVENTORY_STOCK_LOCKED') {
    return data?.message || '庫存項已被其他單據鎖定';
  }

  return data?.message || fallback;
}

export function isStockAdjustmentVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
